type ListsRetrievalError = {
  hasUnExpectedError: boolean;
  message: string;
};

const listsRetrievalError: ListsRetrievalError = {
  hasUnExpectedError: false,
  message: "",
};

export type { ListsRetrievalError };

export { listsRetrievalError };
